import { useState } from "react";
import { Modal } from "@/components/ui-mm/Modal";
import CurrencyPicker from "@/components/mm/CurrencyPicker";
import { BrandMark } from "@/components/mm/Brand";
import { useData } from "@/context/DataContext";
import { useFxRates } from "@/hooks/useFxRates";
import { POPULAR_CUR } from "@/data/constants";
import { curName, curSymbol } from "@/lib/money";
import { t, setLang } from "@/lib/i18n";

export default function Onboarding() {
  const { db, saveSettings } = useData();
  const fx = useFxRates();
  const prefs = db.settings.prefs;
  const [cur, setCur] = useState(prefs.currency || "AUD");
  const [lang, setL] = useState(prefs.lang || "en");
  const [busy, setBusy] = useState(false);
  if (prefs.onboarded) return null;
  const go = async () => {
    setBusy(true);
    try { await saveSettings({ prefs: { ...prefs, currency: cur, lang, onboarded: true } }); } catch (e) { setBusy(false); }
  };
  const chLang = (l) => { setL(l); setLang(l); };
  return (
    <Modal open onClose={go} title={t("Welcome to BudgetPulse")} desc={t("Which currency do you use most?")} testId="onboarding-currency-dialog">
      <div className="mb-4 flex justify-center"><BrandMark className="h-16 w-16" /></div>
      <div className="mm-seg mb-4">{[["en", "English"], ["bn", "বাংলা"]].map(([k, l]) => <button key={k} className={lang === k ? "on" : ""} onClick={() => chLang(k)} data-testid={`onboarding-lang-${k}`}>{l}</button>)}</div>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
        {POPULAR_CUR.map((c) => (
          <button key={c} onClick={() => setCur(c)} className={`rounded-[var(--ri)] border-2 p-2 text-left transition-transform hover:-translate-y-0.5 ${cur === c ? "border-[var(--ac)] bg-[color-mix(in_srgb,var(--ac)_10%,transparent)]" : "border-[var(--bd)]"}`} data-testid={`onboarding-currency-${c}`}>
            <div className="num text-sm font-bold">{curSymbol(c)} {c}</div><div className="truncate text-[11px] text-[var(--mu)]">{curName(c)}</div>
          </button>
        ))}
      </div>
      <div className="mt-3 text-xs font-semibold uppercase tracking-wider text-[var(--mu)]">{t("More currencies")}</div>
      <CurrencyPicker value={cur} onChange={setCur} codes={fx.codes} testId="onboarding-currency-picker" className="mt-1" />
      <p className="mt-4 text-sm text-[var(--mu)]">{t("You can change this any time in Settings.")}</p>
      <button className="mm-btn mt-4 w-full justify-center py-3" onClick={go} disabled={busy} data-testid="onboarding-save-button">{t("Let's start")}</button>
    </Modal>
  );
}
